module.exports = __webpack_public_path__ + "static/media/rounded-plus-grey-icon.9e7719df.svg";